<p-floatlabel class="w-full flex-1 block" [formGroup]="formGroup">
  <input pInputText [type]="type || 'text'" [class]="inputClass"
    [formControlName]="id"
    [maxlength]="maxLength"
    [attr.placeholder]="placeholder || null"
    [id]="id"
    [disabled]="disabled"
    (focusin)="isFocused = true"
    (focusout)="isFocused = false"
    />
  <label [for]="id">{{label}} @if (isFocused && !hideCounter) {
      <span>({{maxLength - value?.length}})</span>
    }</label>
</p-floatlabel>
@if (formError) {
  <app-form-error [message]="formError"></app-form-error>
}
